const ProfileTable = props => {
  const data = props.data
  return (
    <table className="table table-hover profile-table">
      <thead>
        <tr>
          <th scope="col">Type</th>
          <th scope="col" className="text-center">Total</th>
          <th scope="col" className="text-center">Win</th>
          <th scope="col" className="text-center">%</th>
        </tr>
      </thead>
      <tbody>
        {data &&
          data.map(item => (
              <tr key={item.name}>
                <td className="fw-bold">{item.name}</td>
                <td className="text-center">{item.total}</td>
                <td className="text-center">{item.success}</td>
                <td className="text-center">{item.percent}</td>
              </tr>
            )
          )
        }
      </tbody>
    </table>
  )
}

export default ProfileTable
